import { Component, AfterViewInit, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AllService } from '../../rest/all.service';
import { GlobalService } from '../../global/global.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [AllService, GlobalService]
})
export class SidebarComponent implements AfterViewInit {
  isActive: Boolean = true;
  sidebarList: Array<any> = [];
  showMenu: String = '';
  showSubMenu: String = '';
  version = '';
  userSelected = {
    Id_User: Number,
    Id_Customer: Number,
    Id_Company: Number,
    Id_Language: Number,
    Status: String,
    StatusName: String,
    Name: String,
    Img_Path: String,
    Email: String,
    Date_Add: String,
    Password: String,
    CustomerName: String,
    CompanyName: String
  };

  constructor(
    private router: Router,
    private globalService: GlobalService,
    private translate: TranslateService,
    private allService: AllService) {
    this.version = this.globalService.getVersion();
    if (localStorage.getItem('languaje') === 'es') {
      translate.use('es');
    } else if (localStorage.getItem('languaje') === 'en') {
      translate.use('en');
    } else {
      translate.setDefaultLang('es');
      localStorage.setItem('languaje', String('es'));
    }
    this.getSidebarSerivice();
    this.getUserByTokenSerivice();
  }

  connectionNew(link) {
    const redirect = link;
    window.open(redirect, '_blank');
  }

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }
  eventCalled() {
    this.isActive = !this.isActive;

  }
  // End open close
  ngAfterViewInit() {
    $(function () {

      $(".sidebartoggler").on('click', function () {
        if ($("body").hasClass("mini-sidebar")) {
          $("body").trigger("resize");
          $(".scroll-sidebar, .slimScrollDiv").css("overflow", "hidden").parent().css("overflow", "visible");
          $("body").removeClass("mini-sidebar");
          $('.navbar-brand span').show();
          //$(".sidebartoggler i").addClass("ti-menu");
        }
        else {
          $("body").trigger("resize");
          $(".scroll-sidebar, .slimScrollDiv").css("overflow-x", "visible").parent().css("overflow", "visible");
          $("body").addClass("mini-sidebar");
          $('.navbar-brand span').hide();
          //$(".sidebartoggler i").removeClass("ti-menu");
        }
      });

    });
  }

  profile() {
    const redirect = '/profile';
    this.router.navigate([redirect]);
  }

  getUserByTokenSerivice() {
    this.allService.getUserByToken().subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        this.userSelected = resp.data;
      }
    });
  }

  getSidebarSerivice() {
    this.allService.getSidebar().subscribe(resp => {

      if (this.globalService.verifyResponse(resp)) {
        this.sidebarList = resp.data;
      }
    });
  }

  logoutService() {
    this.allService.logout().subscribe(resp => {
      localStorage.setItem('key', '');
      const redirect = '/';
      this.router.navigate([redirect]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts